import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getAggregatorEnvironment = async ({ id, sourceAppId }) => {
  const { data } = await getDataWithDotNet(
    `${ajaxEndpoints.GET_AN_AGGREGATOR_ONBOARDING_STATUS}?customer_id=${id}&source_app_id=${sourceAppId}`,
  );
  return data;
};

export default function useAggregatorEnvironment({ id, sourceAppId }) {
  // The id is a query identifier here
  return useQuery(
    [{ id, sourceAppId }, "getAggregatorEnvironment"],
    getAggregatorEnvironment,
    {
      refetchOnWindowFocus: false,
    },
  );
}
